<template>
  <div class="signature-capture-container">
    <div v-if="loading" class="overlay">
      <loading-icon></loading-icon>
    </div>
    <div v-else class="signature-capture-wrapper">
      <div class="sub-header">complete the form below to hear about the latest news and specials</div>
      <opt-in-terms
          :allowedSms="allowedSms"
          :merchant="merchant"
          @setData="setData">
      </opt-in-terms>
      <signature-pad @setData="setData"></signature-pad>
      <div class="button" @click="submit">done</div>
    </div>
  </div>
</template>

<script>
  import AxiosMixin from '@/mixins/AxiosMixin'
  import LoadingIcon from '@/components/Shared/LoadingIcon'
  import OptInTerms from './OptInTerms'
  import SignaturePad from './SignaturePad'

  export default {
    props: {
      allowedSmsStored: Boolean,
      baseUrl: String,
      merchant: Object,
      phoneNumber: String,
    },

    name: 'SignatureCapture',

    components: {
      LoadingIcon,
      OptInTerms,
      SignaturePad,
    },

    mixins: [AxiosMixin],

    data() {
      return {
        allowedSms: false,
        currentStep: 'signature-capture',
        loading: false,
        signatureFile: null,
      }
    },

    methods: {
      setData(field, value) {
        this[field] = value
      },

      submit() {
        if (!this.signatureFile) { this.$emit('setPageAlert', 'must sign form'); return }

        this.loading = true
        this.axiosMethod({
          url: this.apiUrl,
          methodType: 'patch',
          params: { allowed_sms: this.allowedSms, attachment: this.signatureFile },
          onSuccess: this.submitSuccessHandler,
          onError: this.submitErrorHandler
        })
      },

      submitErrorHandler(error) {
        this.$emit('setErrors', error)
      },

      submitSuccessHandler(response) {
        const walletLink = response?.data?.wallet_url

        if (walletLink) {
          this.redirectTo(walletLink)
        } else {
          this.$emit('setErrors')
        }
      },

      redirectTo(redirectUrl) {
        // this method is used for subscription sharing links routing

        if (location.search) {
          const urlParams = location.search.substr(1).split('&')
          let parsedParams = urlParams.reduce((acc, param) => {
            let splitParams = param.split('=')
            acc[splitParams[0]] = unescape(splitParams[1])
            return acc
          }, {})

          // populate params for sharing links
          if (parsedParams['plan']) {
            redirectUrl = redirectUrl.replace(/\?/, `?plan=${parsedParams['plan']}&`)
          }
          if (parsedParams['link']) {
            redirectUrl = redirectUrl.replace(/\?/, `?link=${parsedParams['link']}&`)
          }
          if (parsedParams['route']) {
            redirectUrl = redirectUrl.replace(/\/profile/, `${parsedParams['route']}`)
          }
        }
        this.loading = false
        window.location.href = redirectUrl
      },

      redirectToJoinForm() {
        this.loading = false
        window.location.href = this.joinLink
      },
    },

    created() {
      this.allowedSms = this.allowedSmsStored
    },

    computed: {
      apiUrl: function() {
        return `${this.baseUrl}/members/${this.phoneNumber}`
      }
    }
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.signature-capture-container
  .sub-header
    color: $title-color
    font-size: 1.25rem
    margin: 1rem auto

  .button
    margin: 2rem auto
</style>